import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import Header from '../header/header';
import Footer from '../footer/footer';
import Navbar from '../navbar/navbar';
import { CdcDownloadManagerComponent } from 'cdc-conte-ui-kit';
import { Auth } from '../../services/auth';
import { RouterServiceConte } from '../../services/router-service';
import { FiltriRicercaGestioneDocumentiService } from '../../services/filtri-ricerca-gestione-documenti';
import { FiltriRicercaRichiesteNuovoInvioService } from '../../services/filtri-ricerca-richieste-nuovo-invio';
import { ZipJobsService } from '../../services/zip-jobs.service';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, Header, Footer, Navbar, CdcDownloadManagerComponent],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export default class MainLayout{
  readonly isNavbarOpened = signal(false);
  isBackdropVisible = signal<boolean>(false);
  router = inject(Router);
  authService = inject(Auth);
  routerServiceConte = inject(RouterServiceConte);
  filtriRicercaService = inject(FiltriRicercaGestioneDocumentiService);
  filtriRicercaRichiesteNuovoInvioService = inject(FiltriRicercaRichiesteNuovoInvioService);
  zipJobsService = inject(ZipJobsService);

  constructor(){
    this.filtriRicercaService.handlerFiltriCachati();
    this.filtriRicercaRichiesteNuovoInvioService.handlerFiltriCachati();
  }

  isNavbarOpen(event: boolean) {
    this.isBackdropVisible.set(event);
  }

  closeNavbar() {
    this.isBackdropVisible.set(false);
  }

  triggerIndietro(){
    this.filtriRicercaService.indietroBtnHandler$.next(true);
  }

}
